import { theme } from '@beamery/lib-ds-theme';
import React from 'react';
import { HeadingElement } from './heading.styles.js';
export const Heading = React.forwardRef(({ variant = '1', ...rest }, ref) => (React.createElement(HeadingElement, { ref: ref, elementType: `h${variant}`, ...theme.styles.headings[variant], ...rest })));
//# sourceMappingURL=heading.component.js.map